import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerHierarchy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#4996b2",
      }}
      d="M12 8V5.9h-1V8H8v3.1h1V9h5v2.1h1V8z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M16 11h-3c-.5 0-1 .5-1 1v1c0 .5.5 1 1 1h3c.5 0 1-.5 1-1v-1c0-.5-.5-1-1-1zm0 2h-3v-1h3v1zM10 11H7c-.5 0-1 .5-1 1v1c0 .5.5 1 1 1h3c.5 0 1-.5 1-1v-1c0-.5-.5-1-1-1zm0 2H7v-1h3v1zM10 6h3c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1h-3c-.5 0-1 .5-1 1v1c0 .5.5 1 1 1zm0-2h3v1h-3V4z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerHierarchy);
export default Memo;
